import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as profileActions from '../../../actions';
import * as Buttons from '../../ui/buttons';
import * as AchievementsElements from './index';
import * as helpers from '../../../helpers/generalHelpers';
import * as UI from '../../../elements/ui';

class Achievements extends Component {
	constructor() {
		super();
		this.state = {
			openFormId: null,
			isThisFormOpen: false,
			stayOpen: false,
			globalFormId: null,
			error: false,
			postError: false,
		};
	}

	componentWillMount() {
		const globalFormId = helpers.randomNum();
		this.setState({ globalFormId });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.formOpenId === null) this.setState({ error: false });
	}

	handleEditing = toggle => {
		const { setFormVisibility, isOtherFormOpen } = this.props,
			{ globalFormId } = this.state;

		if (toggle) {
			if (isOtherFormOpen) return this.setState({ error: true });
			else {
				this.setState({ isThisFormOpen: true });
				return setFormVisibility(toggle, globalFormId);
			}
		} else {
			this.setState({ isThisFormOpen: false });
			return setFormVisibility(toggle, null);
		}
	};

	callBackFromApi = error => {
		if (error) return this.setState({ postError: error.status });
		const { setFormVisibility } = this.props,
			{ stayOpen } = this.state;
		this.setState({ isThisFormOpen: false });
		setFormVisibility(false, null);
		return stayOpen ? null : this.handleEditing(false);
	};

	handleAdding = form => {
		const { pressApiCall, awardsApiCall, publicationsApiCall } = this.props,
			payload = form ? form : null,
			type = form ? form.type : 'DELETE',
			formId = this.state.openFormId;
		return (
			(formId === 1 &&
				pressApiCall(form.person_id, payload, type, this.callBackFromApi)) ||
			(formId === 2 &&
				awardsApiCall(form.person_id, payload, type, this.callBackFromApi)) ||
			(formId === 3 &&
				publicationsApiCall(
					form.person_id,
					payload,
					type,
					this.callBackFromApi
				))
		);
	};

	render() {
		const { press, awards, publications, networkId, ui } = this.props,
			{ guestMode } = ui,
			{ openFormId, isThisFormOpen, error, postError } = this.state;

		if (press.noData && awards.noData && publications.noData && guestMode)
			return null;

		return (
			<section id="achievements" className="user-achievements">
				<div className="container">
					<div className="row">
						<div className="col-12 profile-list">
							<div className="profile-section-header-box">
								<h2 className="h2 profile-section-header">Achievements</h2>
								<UI.OpenFormError error={error} />
								<UI.PostErrorMessage
									error={postError}
									onClose={() => this.setState({ postError: false })}
								/>
								{/*show when not in guestMode*/}
								{!guestMode && (
									<div>
										{/* <p className="p-tag section-visibility-info">Achievements are common across all subscribed
                                        networks.</p> */}
										<Buttons.AddButtonAchievements
											isOpen={isThisFormOpen}
											handleAdding={() => this.handleEditing(!isThisFormOpen)}
											networkId={networkId}
										/>
									</div>
								)}
								{/*/////////*/}
							</div>
							<AchievementsElements.SelectAchievementType
								isOpen={isThisFormOpen}
								openFormId={openFormId}
								onCancel={() => this.setState({ openFormId: null })}
								setOpenForm={openFormId => this.setState({ openFormId })}
								handleAdding={form => this.handleAdding(form)}
								{...this.props}
							/>
							{press.body && press.body[0] && (
								<div className="category-achievements press">
									<div className="profile-section-header-box">
										<h3 className="h3 achievements-name">Press</h3>
									</div>
									<AchievementsElements.PressList {...ui} data={press.body} />
								</div>
							)}
							{awards.body && awards.body[0] && (
								<div className="category-achievements awards">
									<div className="profile-section-header-box">
										<h3 className="h3 achievements-name">Awards</h3>
									</div>
									<AchievementsElements.AwardsList {...ui} data={awards.body} />
								</div>
							)}
							{publications.body && publications.body[0] && (
								<div className="category-achievements publications">
									<div className="profile-section-header-box">
										<h3 className="h3 achievements-name">Publications</h3>
									</div>
									<AchievementsElements.PublicationsList
										{...ui}
										data={publications.body}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</section>
		);
	}
}

const mapStateToProps = state => {
	return {
		formOpenId: state.profile.forms.Id,
		isOtherFormOpen: state.profile.forms.editing,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setFormVisibility: (toggle, formId) =>
			dispatch(profileActions.showForm(toggle, formId)),
		pressApiCall: (personId, payload, type, callback) =>
			dispatch(profileActions.pressApiCall(personId, payload, type, callback)),
		awardsApiCall: (personId, payload, type, callback) =>
			dispatch(profileActions.awardsApiCall(personId, payload, type, callback)),
		publicationsApiCall: (personId, payload, type, callback) =>
			dispatch(
				profileActions.publicationsApiCall(personId, payload, type, callback)
			),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Achievements);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/Achievements.js